/**
 * GoogleAnalyticsLoader — Injects gtag.js into the live app when the tenant
 * has saved a Measurement ID + toggled "Enable Tracking" in Settings.
 *
 * Without this loader, the Measurement ID just sits in Mongo and no events
 * ever reach Google Analytics — the user fills it in and rightly wonders
 * "why is GA showing no data?".
 *
 * This component renders nothing; its only job is the side effect of
 * appending two <script> tags to <head> on first mount.
 */
import { useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const SCRIPT_ID = 'konnect-ga-loader';

export default function GoogleAnalyticsLoader() {
  useEffect(() => {
    let alive = true;

    const inject = (measurementId) => {
      // Avoid double-injection if React re-mounts
      if (document.getElementById(SCRIPT_ID)) return;

      const s1 = document.createElement('script');
      s1.id = SCRIPT_ID;
      s1.async = true;
      s1.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
      document.head.appendChild(s1);

      const s2 = document.createElement('script');
      s2.id = SCRIPT_ID + '-init';
      s2.text = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', ${JSON.stringify(measurementId)});`;
      document.head.appendChild(s2);
    };

    axios.get(`${API}/api/integrations/ga`)
      .then(({ data }) => {
        if (!alive) return;
        if (data?.enabled && data?.measurement_id) {
          inject(data.measurement_id.trim());
        }
      })
      .catch(() => { /* unauthenticated public pages skip GA — that's fine */ });

    return () => { alive = false; };
  }, []);

  return null;
}
